export const dateCompare = (
    dateA: Date,
    dateB: Date
): number => {
    return dateA > dateB ? 1 : dateA < dateB ? -1 : 0;
};

